import moment from "moment";
import { getLabel } from "../../../../../hooks/use-labels";
import { getStorageItem } from "../../../../../utils/common-utils";
import { format12HourTime } from "../../../../../utils/common-utils";
import { formatTypeSpanText } from "./DeliveryTypeModal/DeliveryTypeContent/type-content-utils";
import { listDateFormat } from "../../../../../utils/constants";

export const getDeliveryTypeValue = () => {
  const deliveryType = getStorageItem("deliveryType");

  if (!deliveryType) return "";

  const {
    scheduled,
    consumerPickup,
    express,
    standard,
    free,
    code,
    defaultTitle,
    timeSlot,
  } = deliveryType;

  let title = getLabel(code) || defaultTitle;

  const normalDelivery = express || standard || free;

  if (normalDelivery) {
    return `${title} - ${formatTypeSpanText(deliveryType)}`;
  } else if (scheduled && timeSlot.scheduled) {
    if (timeSlot) {
      return `${title} - ${formatSlotTime(timeSlot)}`;
    }

    return title;
  } else if (consumerPickup) {
    if (timeSlot) {
      return `${title} - ${formatSlotTime(timeSlot)}`;
    }

    return title;
  }
};

export const formatSlotTime = (timeSlot, placeholder) => {
  const { from, till, date } = timeSlot;
  const formattedDate = moment(date).format(listDateFormat);

  const startTime = format12HourTime(date, from, true);
  const endTime = format12HourTime(date, till, true);

  return `${formattedDate} ${startTime} ${placeholder || "-"} ${endTime}`;
};
